import React from 'react'

import SelectBox from '../ui/selectBox'
import { STATIC_CURRENCIES } from '../../lib/currencies'

type Props = {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  defaultValue?: string
  value?: string
  disabled?: boolean
  label?: string
}

const StaticCurrencySelector: React.FC<Props> = ({
  defaultValue,
  value,
  onChange,
  disabled = false,
  label = 'Currency',
}) => {
  const options = STATIC_CURRENCIES.map((currency) => ({
    label: `${currency.name} | ${currency.symbol}`,
    value: currency.code,
  }))

  return (
    <SelectBox
      label={label}
      id='currencyCode'
      name='businessDetails.currency.code'
      options={options}
      defaultValue={value === undefined ? (defaultValue as string) : undefined}
      value={value}
      onChange={onChange}
      required
      disabled={disabled}
    />
  )
}

export default StaticCurrencySelector
